<template>
  <!-- ป้ายผลตรวจสลิป (Convinapp) check มาจาก backend SlipVerifier::summarize / present -->
  <span v-if="check" class="d-inline-flex flex-wrap align-items-center">
    <span class="badge text-xs-1/2 rounded-lg" :class="badgeClass" v-b-tooltip.hover :title="tooltip">
      <i class="mdi mr-1" :class="icon"></i>{{ check.label }}
    </span>
    <!-- ตรวจไม่สำเร็จเพราะฝั่งระบบ (เครดิตหมด ฯลฯ) ตรวจทุกสลิปของใบนี้ใหม่ -->
    <button v-if="check.retryable && recheckKind && recheckId && canRecheck" type="button"
      class="btn btn-link btn-sm p-0 ml-1 text-xs-1/2" :disabled="loading" @click.stop="recheck">
      <i class="mdi" :class="loading ? 'mdi-loading mdi-spin' : 'mdi-refresh'"></i> ตรวจอีกครั้ง
    </button>
  </span>
  <span v-else class="text-gray-300 text-xs-1/2">–</span>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'SlipVerifyBadge',
  props: {
    check: { type: Object, default: null },
    // payment (ใบรับเงิน uuid) | invoice (ใบแจ้งหนี้ใบจอง uuid) ไม่ส่ง = ไม่มีปุ่มตรวจอีกครั้ง
    recheckKind: { type: String, default: '' },
    recheckId: { type: [String, Number], default: null },
    // role ที่ API ตรวจซ้ำยอม (SlipVerifyController) ไม่ยอม = ไม่โชว์ปุ่ม
    canRecheck: { type: Boolean, default: true },
  },
  data() {
    return { loading: false }
  },
  computed: {
    badgeClass() {
      if (!this.check) return ''
      return this.check.level === 'ok' ? 'badge-success' : this.check.level === 'danger' ? 'badge-danger' : 'badge-warning'
    },
    icon() {
      if (!this.check) return ''
      return this.check.level === 'ok' ? 'mdi-check-decagram' : this.check.level === 'danger' ? 'mdi-alert-octagon' : 'mdi-alert'
    },
    tooltip() {
      if (!this.check) return ''
      const parts = [this.check.message]
      if (this.check.slip_amount_total != null) {
        parts.push(`ยอดในสลิป ${this.money(this.check.slip_amount_total)}`)
      }
      if (this.check.slip_count > 1) {
        parts.push(`${this.check.slip_count} สลิป`)
      }
      return parts.filter(Boolean).join(' · ')
    },
  },
  methods: {
    async recheck() {
      try {
        this.loading = true
        const res = await Vue.prototype.$axios.post(`${Vue.prototype.$host}/api/v1/slip-verify/${this.recheckKind}/${this.recheckId}`)
        const check = res.data && res.data.check
        this.$emit('updated', check)
        if (check && check.retryable) {
          const msg = check.message || 'ยังตรวจไม่ได้'
          this.$swal ? this.$swal({ icon: 'warning', text: msg }) : alert(msg)
        }
      } catch (error) {
        const msg = (error.response && error.response.data && error.response.data.message) || 'ตรวจสลิปไม่สำเร็จ'
        this.$swal ? this.$swal({ icon: 'error', text: msg }) : alert(msg)
      } finally {
        this.loading = false
      }
    },
    money(v) {
      return parseFloat(v || 0).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
  },
}
</script>
